import { useMutation } from 'react-query'

import { ApiResponseStatus } from '../../../common/api/constants/api-response.status'
import { useUserStore } from '../../user/stores/user.store'
import { authApi } from '../api/auth.api'
import { LoginInfo, RegisterInfo } from '../types/auth.types'

export const useRegister = () => {
  return useMutation((registerInfo: RegisterInfo) => {
    return authApi.register(registerInfo)
  })
}

export const useLogin = () => {
  const userStore = useUserStore()

  return useMutation(async (loginInfo: LoginInfo) => {
    try {
      const loginResult = await authApi.login(loginInfo)
      if (loginResult.status === ApiResponseStatus.Success) {
        userStore.setUser({
          ...loginResult.user,
          token: loginResult.token,
        })
      }

      return loginResult
    } catch (error: any) {
      return { status: ApiResponseStatus.Error, code: error.status, data: error.response?.data }
    }
  })
}

export const useLogout = () => {
  const userStore = useUserStore()

  return useMutation(async () => {
    try {
      const logoutResult = await authApi.logout()
      if (logoutResult.status === ApiResponseStatus.Success) {
        userStore.logout()
      }

      return logoutResult
    } catch (error: any) {
      return { status: ApiResponseStatus.Error, code: error.status }
    }
  })
}
